import React, { useContext } from 'react';
import { SelectField } from '@ubeya/shared-web/components';
import useAddNewSelector from '@ubeya/shared-web/hooks/useAddNewSelector';
import useDepartments from '@ubeya/shared/hooks/account/useDepartments';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import DepartmentsModal from 'settings/components/AccountSettings/Departments/DepartmentsModal';

// eslint-disable-next-line
const DepartmentSelectField = ({ name = 'departmentId', title, onAdd, ...restSelectProps }) => {
  const { t } = useContext(ConfigContext);

  const { departmentsOptions: defaultDepartmentsOptions, addDepartment } = useDepartments();
  const {
    isOpen: departmentsModalIsOpen,
    setIsOpen: setDepartmentsModalIsOpen,
    options: departmentsOptions,
    onChange: onChangeDepartment
  } = useAddNewSelector({ options: defaultDepartmentsOptions, addText: 'addNewDepartment' });

  return (
    <>
      <SelectField
        name={name}
        title={t('department')}
        options={departmentsOptions}
        isMulti={false}
        onChange={onChangeDepartment}
        creatable
        {...restSelectProps}
      />

      {departmentsModalIsOpen && (
        <DepartmentsModal
          selectedDepartment={{ name: typeof departmentsModalIsOpen === 'string' ? departmentsModalIsOpen : '' }}
          onClose={() => setDepartmentsModalIsOpen(false)}
          onConfirm={async (values) => {
            const { data } = await addDepartment(values);
            onAdd(data?.id);
          }}
        />
      )}
    </>
  );
};

export default DepartmentSelectField;
